<script setup>
import { provide } from 'vue'
import PurchaseOrderForm from '@/components/Compras/purchaseOrders/PurchaseOrderForm.vue'
import { useActiveScreen } from '@/composables/useActiveScreen'

defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['item-atualizado', 'cancelar', 'show-notification'])

// Fornece o contexto de que este formulário NÃO está em drilldown
// (evita renderizar ComexPipelineStatus desnecessariamente)
provide('isStandaloneCadastro', true)

// Registra o formulário real para o resolvedor de tela ativa
// (RAG, RBAC, etc. consultam useActiveScreen().activeForm)
const { setActiveForm } = useActiveScreen()
setActiveForm('PurchaseOrderForm')
</script>

<template>
  <PurchaseOrderForm
    :item-para-editar="itemParaEditar"
    funcao="edicao"
    :drilldown-mode="false"
    :contexto-pai="{}"
    :pipeline-props="{}"
    @item-atualizado="(item) => emit('item-atualizado', item)"
    @cancelar="emit('cancelar')"
    @show-notification="(notif) => emit('show-notification', notif)"
  />
</template>
